/* unplugin-vue-components disabled */import { render } from "./AuthLinkList.vue?vue&type=template&id=27c22cbc&scoped=true&ts=true"
import script from "./AuthLinkList.vue?vue&type=script&lang=ts"
export * from "./AuthLinkList.vue?vue&type=script&lang=ts"

import "./AuthLinkList.vue?vue&type=style&index=0&id=27c22cbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c22cbc"]])

export default __exports__